export default "__VITE_ASSET__D5vRAl9h__"